import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { truncate } from 'fs';
import { PageService } from '../services/page.service';
import { StorageModule } from '../utils/storage.module';
import { Injectable } from "@angular/core";

@Injectable()
export class ProposalAccessGuard  {
    constructor(public storage: StorageModule, public pageService:PageService){}

    canActivate(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): boolean {
        try{

          const current = this.storage.getCurrentStepData()

          const steps:Array<string> = Array.isArray(next.data.route.stepId) ? next.data.route.stepId:[next.data.route.stepId];

          if(current && next.data.route && steps.includes(current.nextStep)){
            return true;
          }
          else{
            this.pageService.goToLanding();
          }

        }catch(error){
          this.pageService.goToLanding();
        }
        
    }
  }
